import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';

const CTASection = ({ title, subtitle }) => {
  const whatsappLink = `https://wa.me/55${companyInfo.whatsapp}?text=Olá! Gostaria de um orçamento.`;

  return (
    <section className="py-16 bg-[#8DC63F]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {title || 'Precisa de assistência técnica?'}
          </h2>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            {subtitle || 'Entre em contato agora mesmo e receba um orçamento gratuito. Atendimento rápido e garantia em todos os serviços!'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="bg-[#2B3990] hover:bg-[#1e2a6e] text-white font-semibold px-8 py-6 text-lg">
                <Phone size={20} className="mr-2" />
                Chamar no WhatsApp
              </Button>
            </a>
            <a href={`tel:${companyInfo.whatsapp}`}>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-[#8DC63F] font-semibold px-8 py-6 text-lg">
                Ligar: {companyInfo.whatsappFormatted}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;